/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.container[_ngcontent-%COMP%]{height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.message[_ngcontent-%COMP%]{font-size:1.53rem;line-height:1.3em}.message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--mmi-secondary-btn);cursor:pointer}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/auth/inactive-account/inactive-account.component.scss.shim.ngstyle.js.pre-build-optimizer.js